import { gql } from '@apollo/client';

/** Los campos que devuelven las tres mutations del catálogo. */
const PRESET_FIELDS = `
  id
  name
  isActive
  roadIDs
  roadRanges {
    roadId
    pkInitKm
    pkInitMeter
    pkEndKm
    pkEndMeter
  }
`;

/** Alta y edición en una sola mutation (doctrina `save<Entity>`). */
export const SAVE_SURVEILLANCE_ROUTE_PRESET = gql`
  mutation SaveSurveillanceRoutePreset($input: SaveSurveillanceRoutePresetInput!) {
    saveSurveillanceRoutePreset(input: $input) {
      ${PRESET_FIELDS}
    }
  }
`;

/** Baja lógica: la plantilla deja de ofrecerse en el asistente, no se borra. */
export const SET_SURVEILLANCE_ROUTE_PRESET_ACTIVE = gql`
  mutation SetSurveillanceRoutePresetActive($id: ID!, $isActive: Boolean!) {
    setSurveillanceRoutePresetActive(id: $id, isActive: $isActive) {
      ${PRESET_FIELDS}
    }
  }
`;

/**
 * Borrado duro. Es seguro porque ningún recorrido apunta a la plantilla: el
 * asistente copia su contenido, no la referencia.
 */
export const DELETE_SURVEILLANCE_ROUTE_PRESET = gql`
  mutation DeleteSurveillanceRoutePreset($id: ID!) {
    deleteSurveillanceRoutePreset(id: $id)
  }
`;
